import { forwardRef } from "react";
import { useId } from "react";
function SvgRawPlayIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="M5 4.832a1 1 0 0 1 1.54-.842l11.152 7.169a1 1 0 0 1 0 1.682L6.54 20.01A1 1 0 0 1 5 19.17V4.831z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawPlayIcon);
export default ForwardRef;
